module.exports = __webpack_public_path__ + "static/media/janhavi_jain.c46533d9.png";